import { __assign } from "tslib";
import * as React from 'react';
import Icon from './icons';
export default function LoadingMask(props) {
    return (React.createElement("div", { className: "zent-loading-mask", "data-zv": '8.4.0' },
        React.createElement(Icon, __assign({}, props))));
}
